import React, { useState } from "react";
import { createPortal } from "react-dom";
import Image from "gatsby-image";
import { rhythm } from "../../utils/typography";
import "./index.css";

const ImageViewer = ({
  children,
  isOpen,
  onClose,
  allImages,
  currentPosition,
}) => {
  const [index, setIndex] = useState(currentPosition);
  if (typeof document === `undefined`) return null;

  console.log(currentPosition);
  let imageClassName = "image-modal";
  if (children.node.fluid.aspectRatio == 1) {
    imageClassName = "image-modal";
  } else if (children.node.fluid.aspectRatio > 1.0) {
    imageClassName = "image-modal-wide";
  } else if (children.node.fluid.aspectRatio < 1.0) {
    imageClassName = "image-modal-tall";
  }
  function next() {
    for (let i = 0; i < allImages.length; i++) {
      if (
        allImages[index].node.fluid.originalName ===
          allImages[i].node.fluid.originalName &&
        i != allImages.length - 1
      ) {
        setIndex(i + 1);
        break;
      }
    }
  }
  function previous() {
    for (let i = 0; i < allImages.length; i++) {
      if (
        allImages[index].node.fluid.originalName ===
          allImages[i].node.fluid.originalName &&
        i != 0
      ) {
        setIndex(i - 1);
        break;
      }
    }
  }
  return isOpen
    ? createPortal(
        <div className="modal">
          <button className="close-modal" onClick={onClose}>
            &times;
          </button>
          <div className="image-container-modal">
            <button
              className={
                index === 0 ? "image-previous arrow-disabled" : "image-previous"
              }
              onClick={previous}
            >
              &#8249;
            </button>
            <div onClick={onClose} className={imageClassName}>
              <Image
                fluid={allImages[index].node.fluid}
                style={{ height: `100%` }}
              />
            </div>
            <button
              className={
                index === allImages.length - 1
                  ? "image-next arrow-disabled"
                  : "image-next"
              }
              onClick={next}
            >
              &#8250;
            </button>
            <div className="image-buttons-mobile">
              <button
                className={
                  index === 0
                    ? "image-previous-mobile arrow-disabled"
                    : "image-previous-mobile"
                }
                onClick={previous}
              >
                &#8249;
              </button>
              <button
                className={
                  index === allImages.length - 1
                    ? "image-next-mobile arrow-disabled"
                    : "image-next-mobile"
                }
                onClick={next}
              >
                &#8250;
              </button>
            </div>
          </div>
        </div>,
        document.getElementById("portal")
      )
    : null;
};

export default ImageViewer;
